import { ROUTES } from '@/features/core/container';
import { option } from '@/util/container';
import { component } from '../component';
import { APP_CUSTOMER } from './app.builder';

export default option(ROUTES, async () => {
  return [
    {
      path: '/customer/:customerId/vendor-apis/aareon-api/:vendorApiId',
      component: component('views/aareon-api/AareonApiView.vue'),
      props: true,
      meta: { app: APP_CUSTOMER, key: (): string => `AppCustomer/VendorApis/Aareon` },
      children: [
        {
          path: '/customer/:customerId/vendor-apis/aareon-api/:vendorApiId',
          name: 'AppCustomer/VendorApis/AareonApi',
          meta: { app: APP_CUSTOMER },
          beforeEnter: ({ params }, from, next) =>
            void next({ name: 'AppCustomer/VendorApis/AareonApi/HeatingSystems', params }),
        },
        {
          path: 'heating-systems',
          name: 'AppCustomer/VendorApis/AareonApi/HeatingSystems',
          component: component('views/aareon-api/heating-systems/HeatingSystemsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
        {
          path: 'settings',
          name: 'AppCustomer/VendorApis/AareonApi/Settings',
          component: component('views/aareon-api/settings/SettingsView.vue'),
          props: true,
          meta: { app: APP_CUSTOMER },
        },
      ],
    },
  ];
});
